import { useQuery } from '@apollo/client'
import { getSignedUrl } from 'gql'

import { userQuery, usersQueryForUsersList, userIressQuery, getUsersForReportingQuery, exportUsersForReportingQuery } from 'gql/user'

export const useGetUser = () => {
  const { data, error, loading, refetch } = useQuery(userQuery)
  return {
    user: (data && data.user) || {},
    loading,
    error,
    refetch,
  }
}

export const useGetUserIressDetails = ({ skip }: { skip?: boolean }) => {
  const { data, error, loading, refetch } = useQuery(userIressQuery, {
    skip: skip,
  })
  return {
    user: (data && data.user) || {},
    loading,
    error,
    refetch,
  }
}

interface UseGetUsersProps {
  companyId?: string
  limit?: number
  skip?: number
  searchValue?: string
}

export const useGetUsers = (variables: UseGetUsersProps) => {
  const { data, error, loading, refetch } = useQuery(usersQueryForUsersList, {
    variables,
  })
  return {
    users: data?.getUsers?.users || [],
    count: data?.getUsers?.count || 0,
    loading,
    error,
    refetch,
  }
}

interface UseGetUsersForReportingProps {
  limit?: number
  skip?: number
  filter?: {
    email: string
    isIressCredentialsVerified: boolean | null
    clientsMinCount: number | null
    clientsMaxCount: number | null
  }
}

export const useGetUsersForReporting = (variables: UseGetUsersForReportingProps) => {
  const { data, error, loading, refetch } = useQuery(getUsersForReportingQuery, {
    variables,
  })
  return {
    users: data?.getUsersForReporting?.users || [],
    count: data?.getUsersForReporting?.count || 0,
    loading,
    error,
    refetch,
  }
}

interface UseExportUsersForReportingProps {
  filter?: {
    email: string
    isIressCredentialsVerified: boolean | null
    clientsMinCount: number | null
    clientsMaxCount: number | null
  }
}

export const useExportUsersForReporting = (variables: UseExportUsersForReportingProps) => {
  const { data, error, loading, refetch } = useQuery(exportUsersForReportingQuery, {
    variables,
    skip: true, // Skip automatic execution, only run when refetch is called
  })
  return {
    exportData: data?.exportUsersForReporting || null,
    loading,
    error,
    refetch,
  }
}

export const useGetUserImageFromS3 = (variables: any) => {
  const { data, error, loading, refetch } = useQuery(getSignedUrl, {
    variables,
  })
  return {
    url: data?.getSignedUrl?.url || '',
    loading,
    error,
    refetch,
  }
}
